// extracted by mini-css-extract-plugin
module.exports = {"carouselStyle":"theme_carouselStyle__2cnKx","average":"theme_average__VeDQD","bottomProgress":"theme_bottomProgress__3-vLs"};